<template>
  <div class="aboutWrapper">
    <dwgwcontenheader :imgsrc="img"></dwgwcontenheader>
    <dwgwcontenstabs :contentsList="contentsList">
      <template v-slot:footer>
          <div>
              <div class="imgWrapper">
                <img :src="img2" alt="">
              </div>
              <div class="infoWrapper">
                  <div class="titleSet">
                      <h4>上海</h4>
                      <img :src="img3" alt="">
                      
                  </div>
                  <div>
                    <p>东方希望大厦位于上海陆家嘴金融贸易区——国内外众多驻沪办事机构云集处竹园CBD。东方希望大厦的建筑语言由两个反差元素组成，一个为完美立方体形状的主楼，一个是自由流线型的裙房。上海分公司位于上海陆家嘴金融中心商圈。</p>
                  </div>
              </div>
          </div>
      </template>
      <template v-slot:header>
          <div>
              <div class="infoWrapper">
                  <div>
                      <p>电话：021-58881360</p>
                      <p>联系邮箱：info@deepwin.ai</p>
                      <p>投资及产品咨询：021-58881360, info@deepwin.ai</p>
                    </div>
              </div>
              <div class="imgWrapper imgWrapper2">
                <img :src="img4" alt="">
              </div>
          </div>
      </template>
    </dwgwcontenstabs>
  </div>
</template>
 
<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
import dwgwcontenstabs from "@/components/dwgwcontenstabs";
export default {
  name: "dwgwalxwm",
  components: {
    dwgwcontenheader,
    dwgwcontenstabs,
  },
  data() {
    return {
      img: require("./jpg/location.jpg"),
      img2:require("./jpg/shanghai.jpg"),
      img3:require("./jpg/sh.png"),
      img4:require("./jpg/xiaomishu.jpg"),
      contentsList: [
        {
          title: "蝶威坐标",
          contentData: [],
        },
        {
          title: "联系我们",
          contentData: [],
        },
      ],
    };
  },
};
</script>

<style scoped>
.aboutWrapper {
  width: 1140px;
  margin: 0 auto;
  margin-top: 100px;
}
.joinUS {
  display: inline-block;
  text-align: center;
  text-decoration: none;
  color: #666;
  border: 1px solid #c8ad6d;
  border-radius: 3px;
  margin-top: 50px;
  font-size: 14px;
  padding: 15px 30px;
}
.imgWrapper{
    display: inline-block;
    vertical-align: top;
    width: 30%;
    height: 0;
    overflow: hidden;
    padding-bottom: 40%;
}

.imgWrapper > img {
    width: 100%;
}

.infoWrapper{
        display: inline-block;
        vertical-align: top;
    width: 48%;
    margin: 0;
    padding: 5%;
    height: 100%;
}
.titleSet{
    text-align: left;
}
.titleSet > h4{
        display: inline-block;
    font-size: 30px;
    font-weight: 100;
    margin-left: 9%;
}
.titleSet > img{
        position: absolute;
    left: 46%
}

.imgWrapper2{
    width: 23%;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwlxwm.vue